import React, { useEffect } from 'react';
import '../css/Information.css';
import Information from "../components/Information";
import { contactDetails } from "../config/stockEyesConfig";

function ShippingAndExchangePolicies() {

    useEffect(() => {
        document.title = "Shipping and Exchange Policies";
    }, []);

    return (
        <Information title={"Shipping and Exchange Policies"}>
            <p>At StocksEyes, all our services are delivered digitally, and we want our users to have complete clarity on how we handle shipping and exchange processes.</p>

            <ol>
                <li>Shipping Policy</li>
            </ol>
            <p>We do not offer any physical goods. All products, including our stock data APIs and related tools, are delivered digitally upon successful payment. You will receive immediate access via your registered account or through credentials sent to your registered email address.</p>
            <p>As there is no physical shipping involved, there are no shipping charges or delivery timelines applicable.</p>

            <ol start="2">
                <li>Exchange Policy</li>
            </ol>
            <p>We understand that your requirements may evolve, and you might want to shift to a different subscription tier. Our exchange policy supports upgrades with fair adjustments:</p>
            <ul>
                <li>You may upgrade your subscription at any time during the active period.</li>
                <li>The unused amount from your current subscription will be adjusted towards the new plan.</li>
                <li>No refunds are issued in the case of a downgrade. The downgrade will take effect from the next billing cycle.</li>
            </ul>
            <p>To request an upgrade or downgrade, please contact our support team. Our team will assist you in adjusting your plan accordingly.</p>

            <ol start="3">
                <li>Policy Changes</li>
            </ol>
            <p>StocksEyes reserves the right to update or modify these policies at any time. Any changes will be published on this page. Continued use of our services after changes implies your acceptance of the updated policy.</p>

            <ol start="4">
                <li>Contact for Exchange Support</li>
            </ol>
            <p>For subscription upgrades or changes, reach out to us at <a href={`mailto:${contactDetails.email}`} target="_new">{contactDetails.email}</a> or call {contactDetails.phone}. Please include your full name, registered email, and subscription details to ensure prompt support.</p>
        </Information>
    );
}

export default ShippingAndExchangePolicies;
